import { appMethod as app, appInstance } from '@utils/app';
import * as customEvent from '@utils/customEvent';
import { getCurrentPageQueryParams, convertLineStyleData, convertTagStyle, convertHtmlTag } from '@utils/tools';
import OfficialPage from '../OfficialPage';

import './videoActivityReward.less'

export default class videoActivityReward extends OfficialPage {
  state = {
    activityId: '',
    activityInfo: {},
    franchiseeId: '',
    rewards: [],
    rewardLogo: {
      1: 'https://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/xcx-newcomer/newcomer-coupon.png',
      2: 'https://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/xcx-newcomer/newcomer-integral.png',
      3: 'https://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/xcx-newcomer/newcomer-storeValue.png',
      4: 'https://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/xcx-newcomer/newcomer-vip.png',
      6: 'https://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/xcx-newcomer/newcomer-collect.png',
      7: 'https://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/xcx-newcomer/newcomer-circle.png',
      8: 'https://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/xcx-newcomer/newcomer-scratch.png',
      9: 'https://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/xcx-newcomer/newcomer-egg.png'
    }
  }

  componentWillMount(options = getCurrentPageQueryParams()) {
    let franchisee = options.sub_app_id || ''
    let activityId = options.id || ''
    this.setData({
      franchiseeId: franchisee,
      activityId: activityId
    })
    this.getRewardDetail()
  }
  getRewardDetail = () => {
    let that = this
    app.sendRequest({
      url: '/index.php?r=AppEcommerce/GetUserReward',
      data: {
        sub_shop_app_id: that.data.franchiseeId || '',
        id: that.data.activityId
      },
      method: 'post',
      success: function (res) {
        if (!res.data) {
          return
        }
        that.setData({
          rewards: res.data.received_reward
        })
      }
    })
  }
  toCouponList = () => {
    this.setData({
      showModal: false
    })
    app.turnToPage('/pages/couponList/couponList')
  }
  toCheckRewards = e => {
    let { type, value } = e.currentTarget.dataset
    let path = ''
    switch (type.toString()) {
      case '1':
        path = '/pages/couponDetail/couponDetail?detail=' + value // 优惠券列表
        break
      case '2':
        path = '/pages/myIntegral/myIntegral' // 积分详情
        break
      case '3':
        path = '/pages/balance/balance' // 储值
        break
      case '4':
        path = '/pages/vipCardList/vipCardList' // 会员卡列表
        break
      case '5':
        path = '/pages/vipBenefits/vipBenefits?id=' + this.data.activityId // 会员权益
        break
      case '6':
        path = '/pages/collectStars/collectStars' // 集集乐
        break
      case '7':
        path = '/pages/luckyWheelDetail/luckyWheelDetail' // 大转盘
        break
      case '8':
        path = '/pages/scratch/scratch' // 刮刮乐
        break
      case '9':
        path = '/pages/goldenEggs/goldenEggs' //砸金蛋
        break
    }
    if (this.data.franchiseeId) {
      if (/\?/.test(path)) {
        path = path + '&franchisee=' + this.data.franchiseeId
      } else {
        path = path + '?franchisee=' + this.data.franchiseeId
      }
    }
    app.turnToPage(path)
  }
  render() {
    const {
      showGetUserInfo,
      rewards,
      item,
      rewardLogo
    } = this.state
    return (
      <React.Fragment>
        <div>
          <div className="container">
            {Array.isArray(rewards) && rewards.map((item, index) => {
              return (
                <React.Fragment>
                  <div
                    className="reward-wrap"
                    data-type={item.type}
                    data-value={item.value}
                  >
                    <div className="reward-logo">
                      <img src={rewardLogo[item.type]} />
                      <span>{item.title}</span>
                    </div>
                    <div
                      className="look-detail"
                      data-type={item.type}
                      data-value={item.value}
                      onClick={this.toCheckRewards}
                    >
                      查看
                </div>
                  </div>
                </React.Fragment>
              )
            })
            }
          </div>
        </div>
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/video-activity-reward/videoActivityReward.jsx